import React from 'react';
import { Link } from 'react-router-dom';

const Home: React.FC = () => (
    <section className="home-page">
        <div className="hero">
            <span className="tagline">Appointment ROI Calculator</span>
            <h1>See exactly how every booked appointment contributes to profit.</h1>
            <p>
                Model your marketing funnel from lead to repeat visit, understand the revenue opportunity from each
                cohort, and discover the ROI required to scale your appointment-based business with confidence.
            </p>
            <div className="hero-actions">
                <Link className="primary-button" to="/calculator">
                    Launch Calculator
                </Link>
                <Link className="secondary-link" to="/results">
                    View sample results
                </Link>
            </div>
        </div>

        <div className="highlights">
            <div className="highlight">
                <h2>Model the entire funnel</h2>
                <p>Track how leads convert to appointments, shows, and closed clients in a single dashboard.</p>
            </div>
            <div className="highlight">
                <h2>Project recurring revenue</h2>
                <p>Account for retention to forecast future revenue from each client you win today.</p>
            </div>
            <div className="highlight">
                <h2>Understand ROI instantly</h2>
                <p>
                    Compare projected revenue with marketing and operating costs to understand the return on investment
                    you can expect each month.
                </p>
            </div>
        </div>
    </section>
);

export default Home;
